import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default function ModalConfirmAdd(props) {
  const [styleFadeIn, setFadeIn] = useState(true);
  const closeModaleCancel = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.close();
    }, 400);
  }, []);

  return (
    <StyleRoot>
      <div
        class="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalConfirm"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form
              onSubmit={(event) => {
                event.preventDefault();
                props.submit();
              }}
            >
              <button
                onClick={closeModaleCancel}
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" class="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">Nouvelle admission</h5>
                </section>
                <section>
                  <h5>Êtes vous sûr de vouloir confirmer l'admission ?</h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn-gradient btn-confirm">
                      <img
                        src="img/icon-check-white.svg"
                        className="img-fluid"
                        alt=""
                      />{" "}
                      Confirmer
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
